import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, of } from 'rxjs';
import { PupilInformationPageActions } from '@lyceo/homi/pupils/data-access';
import { LoginSettingsFacade } from '@lyceo/homi/login/data-access';
import { isDefined } from '@lyceo/shared/util';
import { CourseService } from '../../course.service';
import { CourseAPIActions } from './course.actions';

@Injectable()
export class CourseEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly courseService: CourseService = inject(CourseService);
  private readonly loginSettingsFacade: LoginSettingsFacade =
    inject(LoginSettingsFacade);

  public getCoursesByWebsite$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PupilInformationPageActions.init),
      map(() => this.loginSettingsFacade.websiteId()),
      filter(isDefined),
      exhaustMap((websiteId) =>
        this.courseService.getCoursesByWebsite(websiteId).pipe(
          map((courses) =>
            CourseAPIActions.getCoursesByWebsiteSuccess({
              courses,
            }),
          ),
          catchError((error: Error) =>
            of(CourseAPIActions.getCoursesByWebsiteFailure({ error })),
          ),
        ),
      ),
    );
  });
}
